import { StyleSheet, Dimensions } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

const { width } = Dimensions.get('window')

export default StyleSheet.create({
  cardContainer: theme => ({
    paddingVertical: 17.5,
    paddingHorizontal: 16.6,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
    elevation: 2,
    width: Dimensions.get('window').width > 700 ? '100%' : width - 32,
    marginRight: 8.5,
    marginTop: 8.5,
    marginBottom: 15,
  }),
  cancelViewContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginHorizontal: 2.5,
  },
  cancelTextStyle: theme => ({
    color: theme.colors.hyperlinkFive,
    fontSize: 14.6,
    marginHorizontal: 8,
  }),
  infoContainerStyle: {
    alignItems: 'center',
  },
  serviceIconStyle: {
    marginBottom: 22,
  },
  serviceTypeTextStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: Fonts.size.h6,
    color: theme.colors.headerTitleColor,
    alignSelf: 'center',
    ...Fonts.type.bold,
  }),
  dateTextStyle: theme => ({
    fontSize: 16.6,
    color: theme.colors.headerTitleColor,
    ...Fonts.type.bold,
  }),
  buttonsContainerStyle: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: 17.1,
  },
  leftButtonStyle: {
    flex: 1,
    marginRight: 3,
    height: 32,
    marginTop: 30
  },
  rightButtonStyle: {
    flex: 1,
    marginLeft: 3,
    height: 32,
    marginTop: 30
  },
  buttonTextStyle: theme => ({
    fontSize: 16.6,
    color: theme.colors.headerTitleColor,
    ...Fonts.type.bold,
  }),
  storeContainer: theme => ({
    width: '100%',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: theme.colors.shimmerBorder,
    height: 60,
    marginVertical: 15,
  }),
  storeIcon: {
    marginLeft: 20,
  },
  storeDetails: {
    marginLeft: 12,
    height: 10,
    width: '75%',
    marginTop: 10,
  },
  buttonContainer: theme => ({
    width: '100%',
    borderRadius: 6,
    borderWidth: 1,
    borderColor: theme.colors.shimmerBorder,
    height: 40,
    paddingHorizontal: 20,
  }),
  empty: {
    height: 30
  },
  serviceDescription: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 20,
    color: theme.colors.headerTitleColor,
    alignSelf: 'center',
    marginTop: 10,
    textAlign: 'center'
  })
})
